// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LeadParagraph_Wrapper__sout3"};